/* ============================================
   izzi doro — theme javascript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* --- navbar scroll behavior --- */
  const navbar = document.querySelector('.navbar');
  if (navbar) {
    const onScroll = () => {
      if (window.scrollY > 80) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- mobile menu --- */
  const hamburger = document.querySelector('.navbar__hamburger');
  const mobileMenu = document.querySelector('.navbar__mobile-menu');
  const mobileClose = document.querySelector('.navbar__mobile-close');

  const closeMenu = () => {
    if (mobileMenu) {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      if (mobileMenu.classList.contains('active')) {
        closeMenu();
      } else {
        mobileMenu.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMenu);
    }

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });
  }

  /* --- graceful eased scrolling for in-page links --- */
  const navHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--nav-height'), 10
  ) || 72;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // soft ease-in-out so the page glides to rest rather than stopping abruptly
  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  let scrollAnimation = null;
  const smoothScrollTo = (target) => {
    const startY = window.pageYOffset;
    const targetY = Math.max(
      0,
      target.getBoundingClientRect().top + startY - navHeight
    );
    const distance = targetY - startY;

    if (prefersReducedMotion || Math.abs(distance) < 4) {
      window.scrollTo(0, targetY);
      return;
    }

    // duration grows with distance but stays in a calm, unhurried range
    const duration = Math.min(1500, Math.max(850, Math.abs(distance) * 0.55));
    let startTime = null;

    if (scrollAnimation) cancelAnimationFrame(scrollAnimation);
    const step = (now) => {
      if (startTime === null) startTime = now;
      const progress = Math.min(1, (now - startTime) / duration);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) {
        scrollAnimation = requestAnimationFrame(step);
      } else {
        scrollAnimation = null;
      }
    };
    scrollAnimation = requestAnimationFrame(step);
  };

  // resolve an in-page target from a link's href, or null if it's a real navigation
  const inPageTarget = (href) => {
    if (!href) return null;
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return null;
    const path = href.slice(0, hashIndex);
    if (path && path !== '/' && path !== window.location.pathname) return null;
    const hash = href.slice(hashIndex);
    if (hash.length <= 1) return null;
    try {
      return document.querySelector(hash);
    } catch (e) {
      return null;
    }
  };

  document.querySelectorAll('a[href*="#"]').forEach((link) => {
    if (link.classList.contains('hero__explore')) return; // handled below
    const target = inPageTarget(link.getAttribute('href'));
    if (!target) return;
    link.addEventListener('click', (e) => {
      e.preventDefault();
      closeMenu();
      smoothScrollTo(target);
      history.pushState(null, '', link.getAttribute('href').slice(link.getAttribute('href').indexOf('#')));
    });
  });

  /* --- smooth scroll for explore button --- */
  const exploreBtn = document.querySelector('.hero__explore');
  if (exploreBtn) {
    exploreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const href = exploreBtn.getAttribute('href');
      let target = document.querySelector(href);
      if (!target) {
        const hero = document.querySelector('.hero');
        if (hero && hero.nextElementSibling) {
          target = hero.nextElementSibling;
        }
      }
      if (target) {
        smoothScrollTo(target);
      }
    });
  }

  /* --- scroll reveal animations (text, product cards, etc.) --- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    reveals.forEach(el => observer.observe(el));
  }

  /* --- parallax: scroll-linked image movement --- */
  const parallaxElements = document.querySelectorAll('[data-parallax]');

  if (parallaxElements.length > 0) {
    let ticking = false;

    const updateParallax = () => {
      const scrollY = window.scrollY;
      const winH = window.innerHeight;

      parallaxElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elCenter = rect.top + rect.height / 2;
        /* progress: -1 when element is below viewport, 0 at center, +1 above */
        const progress = -(elCenter - winH / 2) / (winH * 0.8);

        const speed = parseFloat(el.dataset.parallaxSpeed) || 0.3;
        const offset = progress * speed * 250;

        const scale = parseFloat(el.dataset.parallaxScale) || 1;
        const dim = parseFloat(el.dataset.parallaxDim) || 1;

        el.style.transform = 'translateY(' + offset + 'px) scale(' + scale + ')';
        el.style.opacity = Math.max(0, Math.min(1, 0.3 + (1 - Math.abs(progress)) * 0.7)) * dim;
      });

      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });

    /* initial position */
    updateParallax();
  }

  /* --- lifestyle carousel --- */
  const lifestyleTrack = document.querySelector('.lifestyle__track');
  if (lifestyleTrack) {
    const prevBtn = document.querySelector('.lifestyle__arrow--prev');
    const nextBtn = document.querySelector('.lifestyle__arrow--next');
    const scrollAmount = 280;

    if (prevBtn) prevBtn.addEventListener('click', () => {
      lifestyleTrack.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      lifestyleTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    /* auto-scroll every 4s, pause on hover */
    let autoScroll = setInterval(() => {
      if (lifestyleTrack.scrollLeft + lifestyleTrack.clientWidth >= lifestyleTrack.scrollWidth - 10) {
        lifestyleTrack.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        lifestyleTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }, 4000);

    lifestyleTrack.addEventListener('mouseenter', () => clearInterval(autoScroll));
    lifestyleTrack.addEventListener('mouseleave', () => {
      autoScroll = setInterval(() => {
        if (lifestyleTrack.scrollLeft + lifestyleTrack.clientWidth >= lifestyleTrack.scrollWidth - 10) {
          lifestyleTrack.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          lifestyleTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }, 4000);
    });
  }

  /* --- product image gallery --- */
  const galleryWrap = document.querySelector('.product-page__main-image-wrap');
  if (galleryWrap) {
    const images = galleryWrap.querySelectorAll('.product-page__image');
    const thumbs = document.querySelectorAll('.product-page__thumb');
    const prevBtn = galleryWrap.querySelector('.product-page__arrow--prev');
    const nextBtn = galleryWrap.querySelector('.product-page__arrow--next');
    let current = 0;

    const goTo = (index) => {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      images[current].classList.remove('active');
      if (thumbs[current]) thumbs[current].classList.remove('active');
      current = index;
      images[current].classList.add('active');
      if (thumbs[current]) thumbs[current].classList.add('active');
    };

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    /* swipe support */
    let touchStartX = 0;
    galleryWrap.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryWrap.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
  }

  /* --- product buy box: tabs, quantity stepper, subscribe toggle --- */
  const buybox = document.querySelector('.buybox');
  if (buybox) {
    const tabs = buybox.querySelectorAll('.buybox__tab');
    const panels = buybox.querySelectorAll('.buybox__panel');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.toggle('is-active', t === tab));
        panels.forEach(p => {
          const match = p.dataset.panel === tab.dataset.tab;
          p.classList.toggle('is-active', match);
          p.hidden = !match;
        });
      });
    });

    /* quantity stepper */
    const qtyInput = buybox.querySelector('.qty-stepper__input');
    buybox.querySelectorAll('.qty-stepper__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.step, 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      });
    });

    /* one-time vs subscribe — only post a selling_plan when subscribing */
    const freq = buybox.querySelector('.buybox__frequency');
    const planRadios = buybox.querySelectorAll('input[name="selling_plan"]');
    const planLabels = buybox.querySelectorAll('.buybox__plan');
    const subNote = buybox.querySelector('.buybox__sub-note');
    const opts = buybox.querySelectorAll('.buybox__opt');

    /* highlight the chosen delivery frequency button */
    planRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        planLabels.forEach(l => {
          const r = l.querySelector('input[name="selling_plan"]');
          l.classList.toggle('is-active', r.checked);
        });
      });
    });

    buybox.querySelectorAll('input[name="purchase_type"]').forEach(radio => {
      radio.addEventListener('change', () => {
        opts.forEach(o => {
          const r = o.querySelector('input[name="purchase_type"]');
          o.classList.toggle('is-active', r.checked);
        });
        const checked = buybox.querySelector('input[name="purchase_type"]:checked');
        const subscribe = checked && checked.value === 'subscribe';
        if (freq) freq.hidden = !subscribe;
        /* only post a selling_plan while subscribing — disabled radios aren't submitted */
        planRadios.forEach(r => { r.disabled = !subscribe; });
        if (subNote) subNote.hidden = !subscribe;
      });
    });
  }

  /* --- product card hover (touch support) --- */
  if ('ontouchstart' in window) {
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('touchstart', () => {
        document.querySelectorAll('.product-card.touched').forEach(c => {
          if (c !== card) c.classList.remove('touched');
        });
        card.classList.toggle('touched');
      }, { passive: true });
    });
  }

});
